export class Tooltip {
    constructor(){
        [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function (element) {
            return new bootstrap.Tooltip(element)
        })
    }
}